<script setup lang="ts">
import LeInflectionSchemeHeader from "@/components/articles/dictsys/inflection-schemes/LeInflectionSchemeHeader.vue";
import LeInflectionSchemeTable from "@/components/articles/dictsys/inflection-schemes/LeInflectionSchemeTable.vue";
import { DictsysSpanishVerbInflectionSchemeHelper } from "@/helpers";
import type { DictsysInflectionSchemeTable, DictsysSpanishVerbInflectionScheme } from "@/types";

const props = defineProps<{
  lemma: string;
  inflectionScheme: DictsysSpanishVerbInflectionScheme;
  language: string;
}>();

const emit = defineEmits<{
  toggleExtraTable: [table: DictsysInflectionSchemeTable];
}>();

const onToggleExtraTable = (table: DictsysInflectionSchemeTable) => {
  emit("toggleExtraTable", table);
};
</script>

<template>
  <div class="le-spanish-verb-inflection-scheme">
    <LeInflectionSchemeHeader
      :header-elements="DictsysSpanishVerbInflectionSchemeHelper.headWord(props.inflectionScheme)"
      :language="props.language"
    />
    <table>
      <LeInflectionSchemeTable
        :tables="DictsysSpanishVerbInflectionSchemeHelper.getTables(props.inflectionScheme)"
        :language="props.language"
        @toggle-extra-table="onToggleExtraTable($event)"
      />
    </table>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-spanish-verb-inflection-scheme {
  display: flex;
  flex-direction: column;
  gap: 10px;

  #media-breakpoint-up(lg, {
    gap: 30px;
  });
}
</style>
